export const roles = {
    '通用': [{
        "type": "aiqi",
        "name": "艾琪，温柔女声"
    },
        {
            "type": "aicheng",
            "name": "艾诚，标准男生"
        },
        {
            "type": "aijia",
            "name": "艾佳，标准女声"
        },
        {
            "type": "siqi",
            "name": "思琪，温柔女声"
        },
        {
            "type": "sijia",
            "name": "思佳，标准女声"
        },
        {
            "type": "sicheng",
            "name": "思诚，标准男声"
        },
        {
            "type": "ruoxi",
            "name": "若兮，温柔女声"
        },
        {
            "type": "aida",
            "name": "艾达，标准男生"
        },
        {
            "type": "ninger",
            "name": "宁儿，标准女声"
        },
        {
            "type": "xiaoyun",
            "name": "小云，标准女声"
        },
        {
            "type": "xiaogang",
            "name": "小刚，标准男生"
        },
        {
            "type": "ruilin",
            "name": "瑞琳，标准女声"
        }
    ],
    '客服': [{
        "type": "aixia",
        "name": "艾夏，亲和女声"
    },
        {
            "type": "aiyue",
            "name": "艾悦，温柔女声"
        },
        {
            "type": "aiya",
            "name": "艾雅，严厉女声"
        },
        {
            "type": "aijing",
            "name": "艾婧，严厉女声"
        },
        {
            "type": "aimei",
            "name": "艾美，甜美女声"
        },
        {
            "type": "siyue",
            "name": "思悦，温柔女声"
        },
        {
            "type": "Aina",
            "name": "艾娜，浙普女声"
        },
        {
            "type": "aishuo",
            "name": "艾硕，自然男声"
        },
        {
            "type": "aiyu",
            "name": "艾雨，自然女声"
        },
        {
            "type": "xiaomei",
            "name": "小美，甜美女声"
        },
        {
            "type": "yina",
            "name": "伊娜，浙普女声"
        },
        {
            "type": "sijing",
            "name": "思婧，严厉女声"
        }
    ],
    // '文学': [{
    //     "type": "aiyuan",
    //     "name": "艾媛，知心姐姐"
    // },
    //     {
    //         "type": "aiying",
    //         "name": "艾颖，软萌童声"
    //     },
    //     {
    //         "type": "aixiang",
    //         "name": "艾祥，磁性男声"
    //     },
    //     {
    //         "type": "aimo",
    //         "name": "艾墨，情感男声"
    //     },
    //     {
    //         "type": "aiye",
    //         "name": "艾晔，青年男声"
    //     },
    //     {
    //         "type": "aide",
    //         "name": "艾德，新闻男声"
    //     },
    //     {
    //         "type": "aiting",
    //         "name": "艾婷，电台女声"
    //     },
    //     {
    //         "type": "aifan",
    //         "name": "艾凡，情感女声"
    //     }
    // ],
    '童声': [{
        "type": "aitong",
        "name": "艾彤，儿童音"
    },
        {
            "type": "aiwei",
            "name": "艾薇，萝莉女声"
        },
        {
            "type": "aibao",
            "name": "艾宝，萝莉女声"
        },
        {
            "type": "xiaobei",
            "name": "小北，萝莉女声"
        },
        {
            "type": "sitong",
            "name": "思彤，儿童音"
        }
    ],
    '英文': [{
        "type": "Luca",
        "name": "Luca，英音男声"
    },
        {
            "type": "Luna",
            "name": "Luna，英音女声"
        },
        {
            "type": "Emily",
            "name": "Emily，英音女声"
        },
        {
            "type": "Eric",
            "name": "Eric，英音男声"
        },
        {
            "type": "Olivia",
            "name": "Olivia，英音女声"
        },
        {
            "type": "Andy",
            "name": "Andy，美音男声"
        },
        {
            "type": "Abby",
            "name": "Abby，美音女声"
        },
        {
            "type": "William",
            "name": "William，英音男声"
        },
        {
            "type": "Lydia",
            "name": "Lydia，英中双语"
        },
        {
            "type": "Wendy",
            "name": "Wendy，英音女声"
        },
        {
            "type": "Harry",
            "name": "Harry，英音男声"
        }
    ],
    // '方言': [{
    //     "type": "qingqing",
    //     "name": "青青，台湾话女声"
    // },
    //     {
    //         "type": "cuijie",
    //         "name": "翠姐，东北话女声"
    //     },
    //     {
    //         "type": "xiaoze",
    //         "name": "小泽，湖南重口音"
    //     },
    //     {
    //         "type": "shanshan",
    //         "name": "姗姗，粤语女声"
    //     },
    //     {
    //         "type": "xiaoyue",
    //         "name": "小玥，四川话女声"
    //     }
    // ]
}
